import { render } from "./FishModal.vue?vue&type=template&id=0cf031a0&scoped=true"
import script from "./FishModal.vue?vue&type=script&lang=js"
export * from "./FishModal.vue?vue&type=script&lang=js"

import "./FishModal.vue?vue&type=style&index=0&id=0cf031a0&scoped=true&lang=css"
import "./FishModal.vue?vue&type=style&index=1&id=0cf031a0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf031a0"]])

export default __exports__